import Layout from "../../layout/main";
import DetailPages from "../../components/customerMyOrganization/DetailPage";
/**
 * CustomerMyOrganizationDetailPage
 *
 * صفحه جزئیات مشتریان سازمان.
 * این کامپوننت از Layout اصلی برنامه برای ساختار کلی استفاده می‌کند و محتوای صفحه را از
 * کامپوننت DetailPages که شامل جزئیات خدمات مشتریان است، بارگذاری می‌کند.
 *
 * @returns JSX.Element
 */

const CustomerMyOrganizationDetailPage = () => {
  return (
    <Layout>
      <DetailPages />
    </Layout>
  );
};

export default CustomerMyOrganizationDetailPage;
